import Base64 from './base64';
import {APIUSERNAME, APIPASSWORD} from '../Config/apiConfig';
import appSettings from '../appSettings.json'

export const API_ACTION_PRODUCTIONORDERSBYMACHINE = "ProductionOrder/GetByMachineId";
export const API_ACTION_LOGIN = "User/Login";
export const API_ACTION_GETBROKERS = "Broker";
export const API_ACTION_GETPURCHASEORDERTYPES = "PurchaseOrderType/GetAllActive";
export const API_ACTION_GETSUPPLIERTYPES = "SupplierType";
export const API_ACTION_GETTRANSPORTTYPES = "TransportType";
export const API_ACTION_GETSUPPLIERS = "Supplier";
export const API_ACTION_GETUOMS = "UnitOfMeasurement";
export const API_ACTION_GETPRODUCTS = "Product";
export const API_ACTION_GETLANGUAGES = "Language";
export const API_ACTION_GETTRANSLATIONS = "Translation";
export const API_ACTION_GETTRANSLATIONVALUES = "TranslationValue";
export const API_ACTION_GETPRICESCHEMES = "PriceScheme";
export const API_ACTION_GETFREECLAUSES = "DocumentText/GetFreeClauses";
export const API_ACTION_GETDOCUMENTTEXTOVERVIEW = "DocumentTextOverview";
export const API_ACTION_GETCOUNTRIES = "Country";
export const API_ACTION_GETPAYMENTTERMS = "PaymentTerm";
export const API_ACTION_SAVEPURCHASEORDER = "PurchaseOrderLogic";
export const API_ACTION_GETPURCHASEORDERS = "PurchaseOrder";
export const API_ACTION_GETNUMBERRANGES = "NumberRange";
export const API_ACTION_INCREASENUMBERRANGE = "NumberRange/IncreaseCurrentNumber";
export const API_ACTION_GETCERTIFICATESBYSUPPLIERID = "Certificate/GetBySupplierID";
export const API_ACTION_GETSYSTEMPARAMETERVALUEBYSYSTEMPARAMETERID = "SystemParameterValue/GetBySystemParameterId";

export const API_ACTION_SAVECERTIFICATE = "Certificate";

export function ComposeUri(action){
    return appSettings.AGROCONTRACT_WEB_API_BASE_URL + action;
}
export function ComposeInterfaceUri(action){
    return appSettings.AGROCONTRACT_WEB_API_BASE_URL + action;
}

export function ComposeAuthToken(){
    //console.log('ComposeAuthToken started')
    return 'Basic ' + Base64.btoa(APIUSERNAME + ':' + APIPASSWORD);
}

